
        import {css} from 'lit';
        export default css`.legend-item{display:flex;vertical-align:center;gap:.25rem}.legend-item .label{margin-bottom:.375rem;align-self:center}`;
    